import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserSecret, faArrowRightFromBracket } from '@fortawesome/free-solid-svg-icons';
import { toast } from 'react-toastify';
import AuthService from '../../services/auth.service';
import './styles.css';

const ImpersonationBanner: React.FC = () => {
  const [isImpersonating, setIsImpersonating] = useState(false);
  const [impersonatedUser, setImpersonatedUser] = useState<any>(null);
  const [originalUser, setOriginalUser] = useState<any>(null);

  useEffect(() => {
    // Check if user is being impersonated using AuthService
    const checkImpersonationStatus = async () => {
      try {
        const response = await AuthService.GetImpersonationStatus();
        const data = response.data;

        setIsImpersonating(data.isImpersonating);
        setImpersonatedUser(data.currentUser);
        setOriginalUser(data.originalUser);
      } catch (error) {
        console.error('Error checking impersonation status:', error);
      }
    };

    checkImpersonationStatus();
  }, []);

  const handleEndImpersonation = async () => {
    try {
      const response = await AuthService.StopImpersonate();
      toast.success('Returned to your admin account');

      // Redirect to admin page
      window.location.href = '/admin/user';
    } catch (error) {
      console.error('Failed to end impersonation:', error);
      toast.error('Failed to end impersonation. Please try again.');
    }
  };

  if (!isImpersonating) {
    return null;
  }

  return (
    <div className="impersonation-banner">
      <div className="impersonation-banner-content">
        <FontAwesomeIcon icon={faUserSecret} className="impersonation-icon" />
        <span>
          You are currently viewing as <strong>{impersonatedUser?.name}</strong>
        </span>
        <button className="btn btn-outline-light btn-sm ms-3" onClick={handleEndImpersonation}>
          <FontAwesomeIcon icon={faArrowRightFromBracket} className="me-1" />
          Return to Admin
        </button>
      </div>
    </div>
  );
};

export default ImpersonationBanner;
